import type { ReactNode } from 'react'
import s from '../styles/auth.module.css'

export function AuthFormHeading({ title, children }: { title: string; children: ReactNode }) {
  return <div className={s.heading}><h1>{title}</h1><p>{children}</p></div>
}
